/* Release Oil Pen bonus (yourTMJ, 2026-10-20). Loaded by snippets/pdp-brick-header.liquid on every page, config in
   window.__OIL_PEN from Liquid.

   Prices are Shopify discounts on the ONE oil product (one line, quantity N, its own inventory):
   - bulk: two automatic discounts, "2+ bottles at $25.50 each" and "4+ bottles at $21.75 each" (no script involved);
   - with a yourTMJ Pen: three codes on the oil, $10 / $12 / $14.75 off each bottle from 1 / 2 / 4 bottles
     ($19 / $17 / $14.25 a bottle). Shopify applies one product discount per line, the best one, so the right code wins
     over the bulk price and over the other two codes by itself.

   This script only keeps those three codes on the cart while a Pen is in it, and takes them off when not. It never
   changes the lines (except a retired tier copy, which becomes the oil). Any code the shopper entered stays: setting
   the cart's codes replaces the whole list, so the list it sends is always the cart's own codes, freshly read, plus or
   minus ours. The codes ride along with a Pen-only cart (Shopify ignores them until oil is added, checkout does not
   show them), so oil added later is priced right on the first render.

   It writes only AFTER the page's own cart call has finished: two cart writes in flight at once overwrite each other
   (tested 2026-10-20: a code update sent alongside an add lost the add). Known gap: oil first, then the Pen page's
   button that jumps straight to checkout, reaches checkout before the codes are on; that checkout has the bulk price. */
(function () {
  if (window.__oilPenBound) return;
  window.__oilPenBound = true;
  var cfg = window.__OIL_PEN;
  if (!cfg || !cfg.codes || !cfg.codes.length) return;
  var nativeFetch = window.fetch; // the script's own calls skip the hook below
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var OURS = cfg.codes.concat(cfg.retired || []).map(up);
  var busy = false, pending = false, writes = 0, MAX_WRITES = 12; // a hard stop against any loop
  var onCartPage = /^\/cart(\/|$|\?)/.test(location.pathname);

  function up(s) { return String(s || '').trim().toUpperCase(); }
  function isOurs(code) { return OURS.indexOf(up(code)) > -1; }
  function penIn(cart) { return (cart.items || []).some(function (it) { return cfg.pens.indexOf(it.handle) > -1; }); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return d && d.code; }).filter(Boolean); }
  function sameSet(a, b) { return a.map(up).sort().join('|') === b.map(up).sort().join('|'); }
  // the retired per-bottle tier copies (yourtmj-oil-2 / -4 / -8) still in a cart become the oil itself
  function legacyUpdates(cart) {
    var legacy = cfg.legacy || {}, oilKey = '', bottles = 0, found = false, updates = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle === cfg.oil.handle) { bottles += it.quantity; if (!oilKey) oilKey = it.key; else updates[it.key] = 0; }
      else if (legacy[it.handle]) { bottles += legacy[it.handle] * it.quantity; updates[it.key] = 0; found = true; }
    });
    if (!found) return null;
    updates[oilKey || cfg.oil.vid] = bottles;
    return updates;
  }
  function codeTarget(cart) { // the full code list the cart should carry, or null when it already does
    var have = codesOf(cart);
    var others = have.filter(function (c) { return !isOurs(c); });
    var want = penIn(cart) ? cfg.codes.slice() : [];
    if (sameSet(have.filter(isOurs), want)) return null;
    return others.concat(want);
  }
  function post(body) {
    writes += 1;
    return nativeFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function refresh() {
    if (onCartPage) { location.reload(); return; }
    try {
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      if (typeof d.init === 'function') d.init();
      if (typeof d.reload === 'function') d.reload(); // re-fetches the drawer + icon sections, never opens it
    } catch (e) {}
  }
  function finish(changed) {
    busy = false;
    var again = pending;
    pending = false;
    if (changed) refresh();
    if (again) setTimeout(sync, 150); // a cart call arrived while this run was in flight
  }
  function sync() {
    if (busy) { pending = true; return; }
    if (writes >= MAX_WRITES) return;
    busy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lu = legacyUpdates(cart);
        var step = lu ? post({ updates: lu }) : Promise.resolve(cart);
        return step.then(function (cart2) {
          var target = codeTarget(cart2);
          if (!target || writes >= MAX_WRITES) return finish(!!lu);
          return post({ discount: target.join(',') }).then(function () { finish(true); });
        });
      })
      .catch(function () { finish(false); });
  }
  // after the page's own cart calls (the buy boxes, the drawer, the cart page); the promise is returned untouched
  if (window.fetch && !window.__oilPenFetchHooked) {
    window.__oilPenFetchHooked = true;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function () { setTimeout(sync, 250); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 300); });
  else setTimeout(sync, 300);
})();
